import { GET_TRANSACTIONS, LOADING, TABLE_LOADING, SAVE_SEARCH_PARAM, SAVE_PAGINATION_DATA, SAVE_PORTAL_USER, GET_BULK_TRANSACTIONS, GET_BULK_TRANSACTIONS_BY_ID, SAVE_PAGINATION_DATA_FOR_VIEW_BULK_BY_ID, BULK_VIEW_LOADING} from '../types';

const initialState = {
    transactions: [],
    bulkTransactions: [],
    bulkTransactionsbyID: [],
    loading: false,
    tableLoading: false,
    bulkViewLoading: false,
    paginationData: {},
    paginationDataViewBulk: {},
    searchParam: {
        pageSize: 20,
        pageNo: 1,
        transactionReference: '',
        status: '',
        startDate: '',
        endDate: '',
        customerEmail: ''
    },
    user: null
}


export default function (state = initialState, action) {
    switch (action.type) {
        case GET_TRANSACTIONS:
            return {
                ...state,
                transactions: action.payload,
                loading: false
            }
        case GET_BULK_TRANSACTIONS:
            return {
                ...state,
                bulkTransactions: action.payload,
                loading: false
            }
        case GET_BULK_TRANSACTIONS_BY_ID:
                return {
                    ...state,
                    bulkTransactionsbyID: action.payload,
                    loading: false
            }
        case SAVE_SEARCH_PARAM:
            return {
                ...state,
                searchParam: action.payload
            }
        case SAVE_PAGINATION_DATA:
            return {
                ...state,
                paginationData: action.payload
            }
        case LOADING:
            return {
                ...state,
                loading: action.payload
            }
        case TABLE_LOADING:
            return {
                ...state,
                tableLoading: action.payload
            }
        case BULK_VIEW_LOADING:
            return {
                ...state,
                bulkViewLoading: action.payload
            }
        case SAVE_PORTAL_USER:
            return {
                ...state,
                user: action.payload
            }
        case SAVE_PAGINATION_DATA_FOR_VIEW_BULK_BY_ID:
                return {
                    ...state,
                paginationDataViewBulk: action.payload
            }
        default:
            return state
    }
}
